import tw, { styled } from 'twin.macro';
import { Container as ContainerBase } from '../shared/Container';
import { Section as SectionBase } from '../shared/Section';

export const Section = styled(SectionBase)`
  ${tw`col-span-3 md:col-span-1`};
`;

export const Container = styled(ContainerBase)``;
